// extracted by mini-css-extract-plugin
module.exports = {"content":"jd","lookName":"kd","shopTheLookContainer":"ld","productContainer":"md","imageContainer":"nd","mainImage":"od"};